import { render, staticRenderFns } from "./FieldData.vue?vue&type=template&id=a3ed3958&"
import script from "./FieldData.vue?vue&type=script&lang=js&"
export * from "./FieldData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports